import { getMemberDismissals } from '@gonfalon/openapi/operations/getMemberDismissals';

import { createQueryOptions } from '../internal/createQueryOptions';

// A member's dismissals only change when this client itself dismisses an announcement, and
// that mutation seeds the cache directly (see useMarkDismissed). New announcements never
// mutate existing dismissals. So there's nothing to refetch for: cache it for the whole
// session to avoid re-requesting it on every mount/focus.
export const getMemberDismissalsQuery = createQueryOptions(getMemberDismissals, {
  staleTime: Infinity,
  gcTime: Infinity,
});
